import * as React from "react";
const SvgFiRrBiking = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-biking_svg__a)">
      <path
        fill="#062147"
        d="M5 23a5 5 0 1 1 0-9.999A5 5 0 0 1 5 23m0-8a3 3 0 1 0 0 6 3 3 0 0 0 0-6m14 8a4.999 4.999 0 1 1 0-9.998A4.999 4.999 0 0 1 19 23m0-8a3 3 0 1 0 0 5.999A3 3 0 0 0 19 15m-6 3v-4a1 1 0 0 0-.349-.758l-2.286-1.965a.99.99 0 0 1-.348-.743.97.97 0 0 1 .274-.71l1.963-1.562a1.007 1.007 0 0 1 1.418.067l2.6 2.4a1 1 0 0 0 .679.266H20a1 1 0 0 0 0-2h-2.66l-2.277-2.103a2.973 2.973 0 0 0-4.105-.152L8.994 8.3a3 3 0 0 0 .068 4.491L11 14.459V18a1 1 0 0 0 2 0m3.5-17a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-biking_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBiking;
